import { useCallback } from 'react';
import { useTellerSession } from '~/common/hooks/use-auth/use-teller-session';
import { routes } from '~/utils/routes';

export const useLocalHooks = (storyId: string) => {
  const { session } = useTellerSession();

  const onClickRegister = useCallback(() => {
    if (typeof window === 'undefined') return;
    const url = (() => {
      return !session?.isAnonymous
        ? routes.profile.planSelection.url()
        : `${routes.register.url(true, undefined, {
            medium: 'vipstory',
            source: storyId,
          })}`;
    })();
    window.location.href = url;
  }, [session?.isAnonymous, storyId]);

  return {
    onClickRegister,
  };
};
